var map = {
	"./Footer": 2918,
	"./Footer.jsx": 2918,
	"./Header": 9713,
	"./Header.jsx": 9713,
	"./ImageLoader": 9146,
	"./ImageLoader.jsx": 9146,
	"./dashboard-header": 8535,
	"./dashboard-header.jsx": 8535,
	"./global": 9007,
	"./global.js": 9007,
	"./global.jsx": 8054,
	"./stripeCheckout": 8662,
	"./stripeCheckout.js": 8662,
	"./testimonialSlider": 2035,
	"./testimonialSlider.jsx": 2035,
	"./useDocumentTitle": 7246,
	"./useDocumentTitle.jsx": 7246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;